<template>
  <div id="social-hub-post-area">
    <div class="post-list-area">
      <transition-group name="list-complete" tag="div">
        <PostCard v-for="(post, index) in posts" :key="post.id + '-' + index" :post="post" />
      </transition-group>
      <infinite-loading @infinite="getData" :identifier="postIdentifier">
        <div class="nomorepost" slot="no-more">
          <span>{{ $t("nomorepost") }}</span>
        </div>
        <Nodata slot="no-results" :title="$t('socialhub.nodatatitle')" :description="$t('socialhub.nodatadesc')" anim="social" :type="filter.type" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import $ from "jquery";
import InfiniteLoading from "vue-infinite-loading";
import { dragscroll } from "vue-dragscroll";
import PostCard from "./PostCard.vue";
export default {
  directives: {
    dragscroll
  },
  components: {
    InfiniteLoading,
    PostCard
  },
  data() {
    return {
      axios,
      moment,
      sharepanel: false,
      postIdentifier: +new Date(),
      isMentionVisible: false,
      users: [],
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      form: {
        id: null,
        postText: null,
        title: null,
        image: null,
        topic: null,
        session: null,
        isDraft: true,
        isAnnouncement: true,
        type: 0,
        mentions: [
          // {
          //   id: null,
          //   type: 0,
          //   color: null,
          //   title: null,
          //   image: null,
          //   fullName: null
          // }
        ]
      },
      loading: false,
      timeout: null
    };
  },
  beforeMount() {
    $(document).on("click", ".open-user", function() {
      var id = $(this).attr("user-id");
      window.vm.$root.$emit("getProfile", id);
    });
    var self = this;
    $(document).on("click", ".read-more", function() {
      if (
        $(this)
          .prev()
          .hasClass("line-clamp")
      ) {
        $(this).text(self.$t("socialhub.hide"));

        $(this)
          .prev()
          .removeClass("line-clamp");
      } else {
        $(this).text(self.$t("socialhub.readMore"));

        $(this)
          .prev()
          .addClass("line-clamp");
      }
    });
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-removePost", async data => {
      var data = this.$toCamel(data.data);
      this.$store.commit("deletePost", data.postId);
    });
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-postCommentDeleted", data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        console.log("postVar");
        var post = this.posts[fIndex];
        console.log("post", post);
        if (data.parentId != null) {
          var pIndex = post.postComments.findIndex(x => x.id == data.parentId);
          if (pIndex != -1) {
            var cIndex = post.postComments[pIndex].subComments.findIndex(x => x.id == data.commentId);
            if (cIndex != -1) {
             post.postComments[pIndex].subComments = post.postComments[pIndex].subComments.filter(x => x.id != data.commentId);
            }
          }
        } else {
          var cIndex = post.postComments.findIndex(x => x.id == data.commentId);
          if (cIndex != -1) {
            console.log('siliniyor');
            post.postComments = post.postComments.filter(x => x.id != data.commentId);
          }
        }
      }
    });
    //NEW POST SOCKET START
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-newPost", async data => {
      var data = this.$toCamel(data.data);
      this.$store.commit("setNewPost", data.post);
    });
    // NEW POST SOCKET END
    //Poll isOver
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-postIsOverChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        this.posts[fIndex].isOver = data.isOver;
      }
    });
    // poll IsOve
    // PostLike Count Changed Start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-postLikeCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        this.posts[fIndex].likes = data.likeCount;
      }
    });
    // PostLike Count Changed End

    // PostCommentCountChanged Start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-postCommentCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        this.posts[fIndex].comments = data.comments;
      }
    });
    // PostCommentCountChanged End
    // postCommentLikeCountChanged Start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-postCommentLikeCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        var post = this.posts[fIndex];
        if (data.parentId != null && data.parentId != undefined) {
          var parentCommentIndex = post.postComments.findIndex(x => x.id == data.parentId);
          if (parentCommentIndex != -1) {
            var commentIndex = post.postComments[parentCommentIndex].subComments.findIndex(x => x.id == data.commentId);
            if (commentIndex != -1) {
              post.postComments[parentCommentIndex].subComments[commentIndex].likeCount = data.likeCount;
            }
          }
        } else {
          var commentIndex = post.postComments.findIndex(x => x.id == data.commentId);
          if (commentIndex != -1) {
            post.postComments[commentIndex].likeCount = data.likeCount;
          }
        }
      }
    });
    // PostCommentLikeCount End

    //PostComment Start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-newComment", async data => {
      var data = this.$toCamel(data.data);
      if (data.comment.parentId == null) {
        var postIndex = this.posts.findIndex(x => x.id == data.postId);
        if (postIndex != -1) {
          var comment = data.comment;
          //SubComment Control
          comment = {
            ...comment,
            subComments: []
          };
          var post = this.posts[postIndex];
          comment.isLiked = false;
          post.postComments.unshift(comment);
        }
      } else {
        var postIndex = this.posts.findIndex(x => x.id == data.postId);
        if (postIndex != -1) {
          var commentIndex = this.posts[postIndex].postComments.findIndex(x => x.id == data.comment.parentId);
          if (commentIndex != -1) {
            console.log(commentIndex);
            this.posts[postIndex].postComments[commentIndex].subComments.unshift(data.comment);
          }
        }
      }
    });

    //PostComment End

    // commentSubCommentCountChange Start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-commentSubCommentCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        var post = this.posts[fIndex];
        var commentIndex = post.postComments.findIndex(x => x.id == data.commentId);
        if (commentIndex != -1) {
          post.postComments[commentIndex].subCommentCount = data.subCommentCount;
        }
      }
    });
    // commentSubCommentCountChange End

    //voteCalculate start
    this.$socket.on("event-social-hub-" + this.currentEvent.id + "-voteCalculated", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.posts.findIndex(x => x.id == data.post.id);
      if (fIndex != -1) {
        this.posts[fIndex].questions[0].options = data.post.questions[0].options;
      }
    });
    //voteCalculate end
  },
  methods: {
    async getData($state) {
      var res = await this.$store.dispatch("getSocialHubList", {
        ...this.filter,
        skip: this.posts.length
      });
      if (res.data.data.items.length == 0) $state.complete();
      else $state.loaded();
    },
    refreshPost() {
      this.$store.commit("resetPosts");
      this.postIdentifier += 1;
      this.$store.commit("resetNewPost");
    }
  },
  beforeDestroy() {
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-commentSubCommentCountChanged");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-voteCalculated");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-newComment");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-postCommentLikeCountChanged");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-postCommentCountChanged");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-postLikeCountChanged");
    this.$socket.off("event-social-hub-" + this.currentEvent.id + "-newPost");
    this.refreshPost();
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    isAttending() {
      return this.$store.getters.getAttending;
    },
    newPost() {
      return this.$store.getters.getNewPost;
    },
    posts() {
      return this.$store.getters.getSocialHubPosts;
    },
    user() {
      return this.$store.getters.getUser;
    },
    filter() {
      return this.$store.getters.getSocialHubFilter;
    }
  },
  watch: {
    "currentEvent.id": function() {
      this.refreshPost();
    },
    "$store.state.socialModule.identifier": function() {
      this.refreshPost();
    },
    "filter.type": async function() {
      this.refreshPost();
    },
    "filter.socialHubPostSortingType": async function() {
      this.refreshPost();
    }
  }
};
</script>

<style lang="less">
#social-hub-post-area {
  position: relative !important;
  padding: 10px 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 6px;
  padding-bottom: 80px;

  .post-list-area {
    & > div {
      display: flex !important;
      flex-direction: column;
      gap: 10px;
      .post {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin-right: 0;
        // padding: 10px;
        // background: #f1f3f6;
        // box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.34);
        // border-radius: 16px;
        border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
        .post-header {
          display: flex;
          align-items: center;
          gap: 10px;
          .profile-image {
            cursor: pointer;
            img {
              width: 40px;
              height: 40px;
              object-fit: cover;
              border: 2px solid #e8ebef;
              border-radius: 50%;
            }
          }
          .user-details {
            cursor: pointer;
            user-select: none;
            display: flex;
            flex-direction: column;
            .username {
              font-weight: 600;
              font-size: 13px;
              line-height: 13px;
              letter-spacing: 0.2px;
            }
            & > span {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0.2px;
              color: #8c929c;
            }
          }
          .post-type {
            margin-left: auto;
            display: flex;
            align-items: center;
            gap: 1rem;
          }
        }
        .topic-area {
          padding: 14px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 12px;
          gap: 0.5rem;
          i {
            color: white;
            font-size: 14px;
            font-weight: 600;
          }
          .topic-title {
            color: white;
            font-weight: 500;
            font-size: 13px;
            line-height: 13px;
            letter-spacing: 0.2px;
          }
        }
        .post-text {
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          color: #505763;
          .text {
            word-wrap: break-word;
          }
          a.open-user {
            color: #268ea6;
            font-weight: 400;
            &:hover {
              text-decoration: none;
            }
          }
          .read-more {
            cursor: pointer;
            letter-spacing: 0.2px;
            text-decoration-line: underline;
            font-weight: 600;
            font-size: 11px;
            line-height: 20px;
          }
        }
        .poll-area {
          display: flex;
          flex-direction: column;
          gap: 1rem;

          .poll-title {
            width: 100%;
            font-weight: 600;
            font-size: 14px;
            line-height: 24px;
            text-align: center;
          }
          .poll-answer-list {
            display: flex;
            flex-direction: column;
            gap: 5px;
            .poll-answer-wrapper {
              border: 1px solid #c8cdd3;
              border-radius: 12px;
              cursor: pointer;
              user-select: none;
              padding: 4px;
              &.selected {
                border: 2px solid #268ea6;
                .answer-item {
                  .polls-bar {
                    background-color: #c1e8f1;
                  }
                }
              }
              i {
                color: #268ea6;
              }
              .answer-item {
                .percentage {
                  flex-shrink: 0;
                }
                padding: 8px 16px;
                font-weight: 500;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 12px;
                font-size: 13px;
                line-height: 18px;
                position: relative;
                span {
                  z-index: 2;
                }
                .polls-bar {
                  position: absolute;
                  background-color: #e8ebef;
                  border-radius: 8px;
                  z-index: 1;
                  left: 0;
                  top: 0;
                  height: 100%;
                }
              }
            }
            .poll-is-over {
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
            }
            .poll-attendings {
              font-weight: 400;
              font-size: 11px;
              line-height: 18px;
              color: #8c929c;
            }
          }

          .poll-button {
            width: 100%;
            padding: 0px 16px;
            .el-button {
              width: 100% !important;
              border-radius: 20px;
            }
          }
        }
        .survey-area {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          .survey-title {
            font-weight: 600;
            font-size: 14px;
            line-height: 24px;
            text-align: center;
          }
          .survey-joined-area {
            padding: 1rem;
            border: 1px solid #c8cdd3;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            gap: 10px;
            .el-button {
              width: 100% !important;
              border-radius: 12px;
              font-weight: 600;
              height: auto !important;
              white-space: break-spaces;
              word-break: break-word;
              font-size: 14px;
              line-height: 24px;
            }
            .estimated-question {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              color: #8c929c;
              text-align: center;
            }
          }
          .survey-questions-area {
            padding: 20px 10px 10px 10px;
            border: 2px solid #c8cdd3;
            border-radius: 16px;
            .survey-question {
              .sub-title {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #505763;
                text-align: center;
                margin-bottom: 1rem;
                .el-input {
                  width: 100%;
                }
              }
            }
            .footer {
              margin-top: 1rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .survey-index {
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                color: #8c929c;
              }
              .next-index {
                .el-button {
                  border-radius: 12px;
                  font-weight: 600;
                  font-size: 14px;
                }
              }
            }
          }
        }
        .post-image {
          img {
            border-radius: 12px;
            max-height: 338px;
            width: 100%;
            object-fit: cover;
          }
        }
        .post-attending {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #8c929c;
          letter-spacing: 0.2px;
        }
        .post-buttons-bar {
          display: flex;
          align-items: center;
          .comment-count,
          .comment {
            font-weight: 400;
            font-size: 11px;
            letter-spacing: 0.2px;
            cursor: pointer;
            color: #292f3b;
            margin-left: 8.5px;
            height: 20px;
            text-align: center;
          }
          .comment-reply {
            font-weight: 600;
            font-size: 11px;
            line-height: 20px;
            text-decoration-line: underline;
            color: #292f3b;
            margin-left: 4px;
            cursor: pointer;
          }
          .liked-area {
            margin-left: auto;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            & > span {
              transition: all 0.2s;
              font-weight: 400;
              font-size: 11px;
              display: flex;
              align-items: center;
            }
          }
        }
        .send-sub-comment {
          position: relative;
          .mention-panel {
            position: absolute;
            top: calc(~"-100% - 1.5rem");
            left: 0;
            display: flex;
            gap: 10px;
            background: #ffffff;
            box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
            border-radius: 12px;
            padding: 10px;
            height: 60px;
            width: 100%;
            overflow-y: hidden;
            overflow-x: hidden;
            .mention-item {
              flex-shrink: 0;
              cursor: pointer;
              display: flex;
              gap: 8px;
              align-items: center;
              .user-image {
                border: 2px solid #e8ebef;
                width: 38px;
                height: 38px;
                border-radius: 50%;
                background-size: cover;
                flex-shrink: 0;
              }
              p {
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                color: #292f3b;
                flex-shrink: 0;
              }
            }
          }
        }
        .send-comment {
          position: relative;
          .mention-panel {
            position: absolute;
            top: calc(~"-100% - 1.5rem");
            left: 0;
            display: flex;
            gap: 10px;
            background: #ffffff;
            box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
            border-radius: 12px;
            padding: 10px;
            height: 60px;
            width: 100%;
            overflow-y: hidden;
            overflow-x: hidden;
            .mention-item {
              flex-shrink: 0;
              cursor: pointer;
              display: flex;
              gap: 8px;
              align-items: center;
              .user-image {
                border: 2px solid #e8ebef;
                width: 38px;
                height: 38px;
                border-radius: 50%;
                background-size: cover;
                flex-shrink: 0;
              }
              p {
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                color: #292f3b;
                flex-shrink: 0;
              }
            }
          }
        }
        .post-comment-area {
          .load-comment-btn {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .post-liked-users-area {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          gap: 8px;
          & > span {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: 0.2px;
            color: #505763;
          }
          .liked-users {
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
              flex-shrink: 0;
              border: 1.5px solid white;
              border-radius: 50%;
              object-fit: cover;
              margin-left: -8px;
              &:first-child {
                margin-left: 0px;
              }
            }
          }
        }
      }
    }
  }
}

.nomorepost {
  margin-top: 20px;
  span {
    background-color: #f1f3f6;
    padding: 10px 12px;
    border-radius: 30px;

    font-weight: 500;
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 0.2px;
    color: #8c929c;
  }
}
.comment-input {
  input {
    border: 1px solid #268ea6 !important;
    border-radius: 12px;
    background-color: white !important;
    padding: 12px 10px;
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #505763;
    height: 48px;
  }
  .el-input__suffix {
    .el-input__suffix-inner {
      .el-input__icon {
        font-weight: bold;
        cursor: pointer;
        color: #505763 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/socialHub/Social.vue